import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { marketplaceApi } from "../services/marketplaceApi";
import { userApi, protectedUserApi } from "../services/userApi";

import userReducer from "./userSlice";

import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { healthApi } from "../services/healthApi";
import { rewardApi } from "../services/rewardApi";
import { mindfulnessApi } from "../services/mindfulnessApi";
import { connectedDevicesApi } from "../services/connectdevicesAPI";

const rootReducer = combineReducers({
  user: userReducer,
  [userApi.reducerPath]: userApi.reducer,
  [marketplaceApi.reducerPath]: marketplaceApi.reducer,
  [protectedUserApi.reducerPath]: protectedUserApi.reducer,
  [healthApi.reducerPath]: healthApi.reducer,
  [rewardApi.reducerPath]: rewardApi.reducer,
  [mindfulnessApi.reducerPath]: mindfulnessApi.reducer,
  [connectedDevicesApi.reducerPath]: connectedDevicesApi.reducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .concat(marketplaceApi.middleware)
      .concat(userApi.middleware)
      .concat(healthApi.middleware)
      .concat(rewardApi.middleware)
      .concat(protectedUserApi.middleware)
      .concat(mindfulnessApi.middleware)
      .concat(connectedDevicesApi.middleware),
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);
